import styled from 'styled-components';

export const Wrapper = styled.div` 
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  user-select: none;
  font-size: 21.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
Title.displayName = 'Title';
